import { render, staticRenderFns } from "./close.modal.vue?vue&type=template&id=60d2e704&lang=html&"
import script from "./close.modal.vue?vue&type=script&lang=js&"
export * from "./close.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports